import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { FormTransformers } from "@/common/utils/formTransformers";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useDeleteTmaisBadge } from "../../hooks/useDeleteTmaisBadge";
import { useGoBack } from "@/common/hooks/useGoBack";

const DeleteBadgeModal = ({id}: {id: string}) => {
  const goBack = useGoBack()
  const queryClient = useQueryClient();

  const [messages, setMessages] = useState<string[] | boolean>(false);

  const { mutate: deleteBadge, isPending: deleteIsPending } = useDeleteTmaisBadge({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tmaisBadges'] })
      queryClient.removeQueries({ queryKey: ['tmaisBadge', id] })
      goBack({ fallback: '/tmais-badges' })
    },
    onError: FormTransformers.errorsTransformer({ setMessages }),
  })

  const handleDelete = () => {
    deleteBadge({ id })
  }

  return (
    <>
      <Modal
        Trigger={(
          <Button
            variant="outline-error"
            operationKlassToCheckPermission="Admin::Tmais::Badges::Destroy"
          >
            Desativar
          </Button>
        )}
        useCancellableFooter
        confirmButtonClassName="rounded-br-lg"
        cancelButtonClassName="rounded-bl-lg"
        onConfirm={handleDelete}
        confirmButtonIsLoading={deleteIsPending}
        title="Você tem certeza?"
        subtitle="Essa ação não é reversível."
        titleClass="text-2xl"
        subtitleClassName="text-base mt-1"
        showClose={false}
      />

      <ModalMessageSimple
        messages={messages}
        setMessages={setMessages}
        isError
      />
    </>
  );
}

export default DeleteBadgeModal;
